<template>
  <div>
    <div class="d-flex justify-center">
      <div ref="chart" id="call-length-chart" class="chart-container"></div>
    </div>
    <ChartLegend :items="legend" />
  </div>
</template>

<script>
import { OrangeChartBars } from 'orange-charts';
import { distinct_colors } from '../../libs/helpers';
import ChartLegend from '../../../../fragments/ChartLegend.vue';

export default {
  name: 'CallLengthDistributionChart',
  props: {
    items: {
      type: Array,
      required: true
    },
    logarithmic: {
      type: Boolean,
      default: false,
    }
  },
  components: { ChartLegend },
  data() {
    const [durationColor] = distinct_colors(this);
    return {
      colors: { duration: durationColor }
    };
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const max_y_value = Math.max(...this.$props.items.map((d) => d.total), 1);
      new OrangeChartBars(this.$props.items)
        .assignSource('total', this.colors.duration)
        .axis('x', {
          label: (v) => v,
          source: 'range',
        })
        .axis('y', {
          log: this.logarithmic,
          min: this.logarithmic ? -1 : 0,
          lines: true,
          label: (v) => {
            if (v * 1 === max_y_value) return this.$l.t('x-calls', '{} calls', [v]);
            if (v * 1 === -1 && this.logarithmic) return 0.1;
            return v;
          },
        })
        .setDataCallback('mouseover', (_, data) => {
          let details = document.getElementById('orange-charts-details');
          if (!details) {
            details = document.createElement('div');
            details.setAttribute('id', 'orange-charts-details');
            document.body.appendChild(details);
          }
          details.innerText = `${data.value} ${data.value === 1 ? this.$l.t('app.call', 'Call') : this.$l.t('app.calls', 'Calls')}`;
        })
        .setDataCallback('mousemove', (e) => {
          const details = document.getElementById('orange-charts-details');
          if (details) {
            details.style.top = `${e.pageY}px`;
            details.style.left = `${e.pageX}px`;
          }
        })
        .setDataCallback('mouseleave', () => {
          const details = document.getElementById('orange-charts-details');
          if (details) details.innerText = '';
        })
        .render('call-length-chart', {
          width: 900,
          height: 400,
        });
    }
  },
  computed: {
    legend() {
      return {
        [this.$l.t('app.total-calls', 'Total calls')]: this.colors.duration
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 400px;
}
</style>
